import { ExportToCSVRouteService } from 'common/data';
import { findParams } from 'core/utils';
import { BaseService } from 'core/services';

class ExportToCSVService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ExportToCSVRouteService());
	}
	
	getOrdersForExport(filter) {
		var url = this.routeService.getOrdersForExport(filter);
		return this.apiClient.post(url, findParams(filter));
	}

}

export default ExportToCSVService;
